<template>
  <a-loading :loading="casinoMeta.loading">
    <casino-form
      mode="edit"
      :casino="casino"
      @submit="handleSubmit"
      @delete="handleDelete"
    />
  </a-loading>
</template>

<script>
  import { CasinoForm } from '@/components'
  import { useCasino, useDeleteCasino, useEditCasino } from './casinoHooks'
  import { ALoading } from 'codefabrik-gui-vue'

  export default {
    name: 'EditCasino',
    components: { CasinoForm, ALoading },
    mixins: [
      useEditCasino('handleSubmit'),
      useCasino('casino'),
      useDeleteCasino('handleDelete')
    ]
  }
</script>

<style scoped>

</style>
